/* Product cards on phones (screens with no hover): swipe the photo left or right to see the second photo.
   A tap still opens the product and an up or down swipe still scrolls the page (the card allows vertical panning only).
   Cards with a single photo have no second photo and no dots, so they are left alone. */
(() => {
  if (!window.matchMedia('(hover: none)').matches) return;
  let card = null;
  let sx = 0;
  let sy = 0;
  let swiped = false;
  let blockClick = 0;

  document.addEventListener('pointerdown', (e) => {
    card = null;
    if (e.pointerType === 'mouse') return;
    const c = e.target.closest && e.target.closest('.cv-card');
    if (!c || e.target.closest('.cv-heart') || !c.querySelector('img.alt')) return;
    const pic = c.querySelector('.cv-card__pic');
    const r = pic.getBoundingClientRect();
    if (e.clientY < r.top || e.clientY > r.bottom) return; // only the photo swipes, not the name or price
    card = c;
    sx = e.clientX;
    sy = e.clientY;
    swiped = false;
  }, { passive: true });

  document.addEventListener('pointermove', (e) => {
    if (!card || swiped) return;
    const dx = e.clientX - sx;
    const dy = e.clientY - sy;
    if (Math.abs(dx) > 14 && Math.abs(dx) > Math.abs(dy) * 1.4) {
      swiped = true;
      card.classList.toggle('is-alt', dx < 0); // left shows the second photo, right goes back to the first
      blockClick = Date.now();
    }
  }, { passive: true });

  const done = () => { card = null; };
  document.addEventListener('pointerup', done, { passive: true });
  document.addEventListener('pointercancel', done, { passive: true });
  // a swipe must not open the product
  document.addEventListener('click', (e) => {
    if (Date.now() - blockClick < 500 && e.target.closest && e.target.closest('.cv-card')) { e.preventDefault(); e.stopPropagation(); blockClick = 0; }
  }, true);
})();
